<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    scrollable
    hide-overlay
    transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar color="white" style="position:relative; z-index: 1">
        <v-btn icon @click.native="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <span>
          {{ documentSelected == null ? '' : documentSelected.document_type.name }}
        </span>

        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            style="height: 50% !important"
            class="mx-1"
            color="success"
            @click="dialogApprove = true"
          >
            Aprovar
          </v-btn>
          <v-btn
            style="height: 50% !important"
            class="mx-1"
            color="error"
            @click="dialogDisapprove = true"
          >
            Reprovar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout justify-end align-center>
        <v-card-text>
          <pdf-viewer
            v-show="showValidation('application/pdf')"
            :progressDialog="progressDialog"
            @document-rendered="onDocumentRendered()"
            @document-errored="onDocumentErrored">
          </pdf-viewer>
          <a :href="getDocumentUrl()"
             v-show="showValidation('application/kml')"
             target="_blank"
             class="v-btn__content mb-1 v-btn v-btn--flat v-btn--small
                     theme--light primary--text"
             download="">Download</a>
        </v-card-text>
      </v-layout>
      <v-dialog
        v-model="dialogDisapprove"
        max-width="350"
        persistent>
        <v-card>
          <v-card-title class="headline">Reprovar documento</v-card-title>

          <v-card-text bold>
            Deseja REPROVAR o documento '
            {{ documentSelected === null ? '' : documentSelected.document_type.name }}'?
          </v-card-text>

          <v-card-text bold>
            <v-textarea
              label="Motivo da reprovação:"
              v-model="refusalReason"
              hint="Digite o texto"
            >
            </v-textarea>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat
              color="red"
              @click="dialogDisapprove = false">
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              flat
              :disabled="refusalReason===''"
              @click="confirmDisapprove(documentSelected)">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogApprove"
        max-width="350"
        persistent
      >
        <v-card>
          <v-card-title class="headline">Aprovar Documento</v-card-title>

          <v-card-text bold>
            Deseja APROVAR o documento '
            {{documentSelected === null ? '' : documentSelected.document_type.name}}'?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat
              color="red"
              @click="dialogApprove = false"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              flat
              @click="approveDocument(documentSelected);"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>


  </v-dialog>
</template>

<script>
import PdfViewer from '@/components/application/PdfViewer';
import EventBus from '@/utils/event_bus';

export default {
  name: 'AdminShowPdfDialog',
  components: {
    PdfViewer,
  },
  data() {
    return {
      application: {},
      dialog: false,
      dialogApprove: false,
      dialogDisapprove: false,
      progressDialog: false,
      documentSelected: null,
      refusalReason: '',
    };
  },
  mounted() {
    EventBus.$on('pdf-selected', (payload) => {
      this.documentSelected = payload.documentSelected;
      this.application = payload.application;
      if (this.documentSelected != null) {
        if (this.documentSelected.last_document_version.mime_type === 'application/pdf') {
          this.progressDialog = true;
          EventBus.$emit('load-pdf', this.documentSelected);
        } else {
          this.dialog = true;
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'default',
            message: 'Documento no formato KML não permite visualização',
            messageIcon: 'mdi-alert-circle',
          });
        }
      }
    });
  },
  computed: {},
  methods: {
    showValidation(fileType) {
      if (this.documentSelected == null) { return false; }
      return this.documentSelected.last_document_version.mime_type === fileType;
    },
    approveDocument(document) {
      this.$store.dispatch('approveDocument', {
        document,
        application: this.application,
      });
      this.dialogApprove = false;
      this.dialog = false;
    },
    confirmDisapprove(document) {
      this.$store.dispatch('disapproveDocument', {
        document,
        refusalReason: this.refusalReason,
        application: this.application,
      });
      this.dialogDisapprove = false;
      this.dialog = false;
    },
    onDocumentRendered() {
      this.progressDialog = false;
      this.dialog = true;
    },

    onDocumentErrored(response) {
      this.progressDialog = false;
      this.dialog = false;
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: response.text,
        messageIcon: 'mdi-alert-circle',
      });
    },

    getDocumentUrl() {
      if (this.documentSelected !== null) {
        return this.documentSelected.last_document_version.document_path.url;
      }
      return '';
    },

    destroyNotPreviewMessage() {
      if (!this.dialog) this.$store.dispatch('toggleSnackbar', { show: false});
    },
  },
  watch: {
    dialog: 'destroyNotPreviewMessage',
  },

};
</script>

<style scoped lang="scss">
</style>
